import React, { ReactElement, ReactNode, useContext } from 'react';

import { NavBarStyles } from 'components/Navigation/constants';
import { ScreenResponsiveLayoutContext } from 'components/ResponsiveLayout';
import {
  CALENDAR_CHART_MARGIN_LEFT,
  NARROW_CALENDAR_CHART_MARGIN_LEFT,
} from 'components/SleepDiaryWeek/constants';
import { roles } from 'cross-platform/utils/roleProps';

import { BarChartLabelCont } from './styled';

export const BarChartLabelContainer = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const { screenWidth, screenHeight } = useContext(
    ScreenResponsiveLayoutContext
  );
  const isMobileWeb =
    screenWidth <= NavBarStyles.navBarCollapseMobileWebBreakPointPx;
  const isLandscape = screenWidth > screenHeight;

  return (
    <BarChartLabelCont
      {...roles('sleepDiaryChartLabelContainer')}
      style={{
        marginLeft:
          isMobileWeb && !isLandscape
            ? NARROW_CALENDAR_CHART_MARGIN_LEFT
            : CALENDAR_CHART_MARGIN_LEFT,
      }}
    >
      {children}
    </BarChartLabelCont>
  );
};
